import "./TestModeBanner.css";

const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
const isTestMode = stripeKey.startsWith("pk_test_");

export default function TestModeBanner() {
  if (!isTestMode) return null;

  return (
    <div className="test-mode-banner" role="alert">
      <span>
        <strong>Test mode</strong> — no real payments are processed.{" "}
        <a
          href="https://stripe.com/docs/keys#obtain-api-keys"
          target="_blank"
          rel="noopener noreferrer"
        >
          Switch to live keys
        </a>
      </span>
    </div>
  );
}
